import { AutocompleteInput, Datagrid, Edit, EditButton, List, NumberInput, ReferenceField, ReferenceInput, required, Show, ShowButton, SimpleForm, SimpleShowLayout, TextField, TextInput } from "react-admin";

const filters = [
    <ReferenceInput source="employee_id" reference="employees" alwaysOn><AutocompleteInput optionText="name" optionValue="id" label="Name"/></ReferenceInput>,
    <ReferenceInput source="employee_id" reference="employees" alwaysOn><AutocompleteInput optionText="registration_number" optionValue="id" label="Reg Number"/></ReferenceInput>,
    <TextInput label="Month Raw(YYYYMM)" source="month_raw" />,
];
export const TransactionList = () => (
    <List filters={filters}>
        <Datagrid bulkActionButtons={false}>
            <ReferenceField source="employee_id" reference="employees"><TextField source="name" /></ReferenceField>
            <ReferenceField source="employee_id" reference="employees" label="Employee Registration number"><TextField source="registration_number" /></ReferenceField>
            <TextField source="month_raw" />
            <TextField source="total_applicable_days" label="Total Workable Days"/>
            <TextField source="non_applicable_days" label="Non applicable Days (Holidays etc)"/>
            <TextField source="worked_days" />
            <TextField source="man_months" />
            <TextField source="holidays" />
            <TextField source="man_hours" />
            <TextField source="man_days" />
            <TextField source="remarks" />
            <ShowButton label="View" />
            <EditButton label="Edit" />
        </Datagrid>
    </List>
);

export const TransactionShow = () => (
    <Show>
        <SimpleShowLayout>
        <ReferenceField source="employee_id" reference="employees"><TextField source="name" /></ReferenceField>
            <ReferenceField source="employee_id" reference="employees" label="Employee Registration number"><TextField source="registration_number" /></ReferenceField>
            <TextField source="month_raw" />
            <TextField source="total_applicable_days" label="Total Workable Days"/>
            <TextField source="non_applicable_days" label="Non applicable Days (Holidays etc)"/>
            <TextField source="worked_days" />
            <TextField source="man_months" />
            <TextField source="holidays" />
            <TextField source="man_hours" />
            <TextField source="man_days" />
            <TextField source="remarks" />
        </SimpleShowLayout>
    </Show>
);

export const TransactionEdit = () => (
    <Edit>
        <SimpleForm>
            Employee Name: <ReferenceField source="employee_id" reference="employees"><TextField source="name" /></ReferenceField>
            <br/>
            Registration Number: <ReferenceField source="employee_id" reference="employees"><TextField source="registration_number" /></ReferenceField><br/>
            Month: <TextField source="month_raw" /><br/>
            Man Months: <TextField source="man_months" /> <br/>
            {/* <TextField source="man_hours" />
            <TextField source="man_days" /> */}
            {/* <TextField source="non_applicable_days" label="Non applicable Days (Holidays etc)"/> */}
            <NumberInput source="total_applicable_days" label="Total Workable Days" onWheel={e => e.target.blur()}  />
            <NumberInput source="worked_days"  onWheel={e => e.target.blur()}  />
            <NumberInput source="holidays"  onWheel={e => e.target.blur()}  />
            <TextInput source="remarks"  validate={required()} fullWidth/>
        </SimpleForm>
    </Edit>
);